import CONSTANTS from 'src/pagesDashboard/Team/context/constants';

export default {
  view: CONSTANTS.VIEWS.ALL_MEMBERS,
  search: '',
  teamList: {
    page: 1,
    pageSize: 50
  }
};
